import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import axios from "axios";
import {SERVICES} from "../permissions";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions, TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import {UpdateDiagnosticServicesTemplateView} from "./UpdateDiagnosticServicesTemplateView";
import {AddDiagnosticServicesTemplateView} from "./AddDiagnosticServicesTemplateView";

export const AddDiagnosticServicesView = (props: { cookieEntityQr: string, category: string, postAction: any }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [availableOptions, setAvailableOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [pricesView, setPricesView] = useState(false);

    function fetchItems() {
        axios.get('/api/backend/templates/fetch/unused/' + props.category + '/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setAvailableOptions(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    const handleSave = () => {
        axios.post('/api/backend/templates/create/inventory/' + props.category + '/' + props.cookieEntityQr, selectedOptions)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (props.postAction) {
                    props.postAction()
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                setErrorMessage("* Something went wrong! Please try again in sometime.")
            })
    }


    const handleChange = (checked, value) => {
        if (checked) {
            setSelectedOptions(oldOpt => {
                return [...oldOpt, {...value, cost: 0, tax: 18}]
            })
        } else {
            setSelectedOptions(oldOpt => {
                return oldOpt.filter(o => o.id != value.id)
            })
        }
    };

    const handleCostChange = (id, value) => {
        selectedOptions.filter(o => o.id == id)[0].cost = value;
    };

    const handleTaxChange = (id, value) => {
        selectedOptions.filter(o => o.id == id)[0].tax = value;
    };

    useEffect(() => {
        if (props.cookieEntityQr) {
            fetchItems();
        }
    }, [props.cookieEntityQr])

    const ITEMS_HEADERS: TableColumnType<any>[] = [
        {
            prop: "name",
            title: "Name",
        },
        {
            prop: "tax",
            title: "Tax %",
            cell: (row) => (
                <> <Form.Control onChange={e => handleTaxChange(row.id, e.target.value)} name="tax"
                                 type="text"
                                 placeholder="Tax %"/></>
            )
        },
        {
            prop: "cost",
            title: "Cost",
            cell: (row) => (
                <><Form.Control onChange={e => handleCostChange(row.id, e.target.value)} name="cost"
                                type="text"
                                placeholder="Enter Cost"/>
                </>
            )
        }
    ];

    function getItemsTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={selectedOptions}
            headers={ITEMS_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >

            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>

        </DatatableWrapper>
        </div>;
    }


    const [showAddModal, setShowAddModal] = useState(false);
    const handleCloseAddModal = () => {
        setShowAddModal(false);
        fetchItems()
    }
    const handleShowAddModal = () => {
        setShowAddModal(true)
    }

    function getModalForAdd() {
        return <Modal
            show={showAddModal}
            onHide={handleCloseAddModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddDiagnosticServicesTemplateView cookieEntityQr={props.cookieEntityQr}
                                                      category={props.category}
                                                      postAction={handleCloseAddModal}/>
            </Modal.Body>
        </Modal>
    }


    return (
        <>
            {!pricesView && <>
                <div className="d-flex justify-content-between">
                    <div className="text-secondary fs-4">Select Services</div>
                    {props.category == 'Lab' && <button className="btn btn-warning btn-sm text-white" onClick={handleShowAddModal}>+ Create New Test</button>}
                    {getModalForAdd()}
                </div>
                {
                    availableOptions.map(cat => {
                        return <>
                            <div className="my-3 fs-5">{cat.subCategory}</div>
                            <div className='pl-5'>{cat.items.map(serv => {
                                return <div className="my-2" key={serv.id}><Form.Check
                                    label={serv.name}
                                    name={cat.subCategory}
                                    type="checkbox"
                                    checked={selectedOptions.filter(o => o.id == serv.id).length > 0}
                                    onChange={e => handleChange(e.target.checked, serv)}
                                /></div>
                            })}</div>
                        </>
                    })
                }
                <div className="mt-5">
                    <button className="btn btn-info text-white"
                            onClick={e => setPricesView(true)}>
                        <>Next</>
                    </button>
                </div>
            </>
            }

            {pricesView && <>
                <div className="text-secondary fs-4 mb-3">Add Prices</div>
                {getItemsTable()}
                <div className="mt-5 d-flex gap-2">
                    <button className="btn btn-warning text-white"
                            onClick={e => setPricesView(false)}>
                        <>&lt; Back</>
                    </button>
                    <button className="btn btn-info text-white"
                            onClick={handleSave}>
                        <>Save</>
                    </button>
                </div>

            </>}

            {errorMessage &&
                <div className="text-danger fs-5">{errorMessage}</div>
            }

        </>
    );
};
